import React from "react";
import { Block } from "react-native-responsive-layout";

/**
 * Convenient component that adds spacing to the block of a section in a grid within an form component.
 */
const FormCell = props => {
  const propKeys = Object.keys(props),
    style = { padding: 10 },
    styleProps = {};
  
  // We loop through all of the styles that have been applied to the cell and add the padding to it (for different size screens)
  for (let propKey of propKeys) {
    if (propKey.endsWith("tyle")) {
      styleProps[propKey] = [props[propKey], style];
    }
  }

  if (!styleProps.style) {
    // If no style has been specified for the cell, we add our default to give us spacing between cells
    styleProps.style = style;
  }

  return <Block {...props} {...styleProps} />;
};

export default FormCell;
